import * as React from "react";
import { SVGProps } from "react";

export const EmailIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg style={{ cursor: "pointer" }} xmlns="http://www.w3.org/2000/svg" width={18} height={14} {...props}>
        <path
            data-name="Path 5249"
            d="M9 8.148 1.1.21A1.8 1.8 0 0 1 1.929 0h14.142a1.8 1.8 0 0 1 .829.21ZM17.807 1.2 9.45 9.6a.6.6 0 0 1-.874 0L.219 1.2A2.248 2.248 0 0 0 0 2.1v9.8A2.02 2.02 0 0 0 1.929 14h14.142A2.02 2.02 0 0 0 18 11.9V2.1a2.255 2.255 0 0 0-.193-.9Z"
            fill="#575756"
        />
    </svg>
);
